import { Directive } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appPageFooter]',
})
export class PageFooterDirective {
  constructor() {}
}
